module.exports = __webpack_public_path__ + "img/diaspora.f5cb1aa7.svg";